import React, { useState } from "react";
import { toast } from "sonner";
import { FileText, Megaphone, MessageSquareReply, Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import { Panel } from "@/components/portal/crm/kit";
import { ConnieMark } from "@/components/connie/ConnieMark";
import { ConnieText } from "@/components/connie/ConnieText";

const ACTIONS = [
  { key: "summary", label: "Summarise the case", icon: FileText },
  { key: "chase", label: "Chase the desks", icon: Megaphone },
  { key: "reply", label: "Reply on the thread", icon: MessageSquareReply },
];

/** Connie on this case — three one-click jobs in the Hub case room. Chases and replies go out straight away. */
export function ConnieCaseCard({ leadId, onChanged }) {
  const [busy, setBusy] = useState(null);
  const [out, setOut] = useState(null);

  const run = async (key) => {
    setBusy(key); setOut(null);
    try {
      const r = (await api.post(`/hub/connie/cases/${leadId}/${key}`)).data;
      if (key === "chase") {
        if (r.ok) toast.success(r.message); else toast.message(r.reason);
        setOut({ key, text: r.ok ? r.message : r.reason });
      } else {
        setOut({ key, text: r.text });
        if (key === "reply" && r.posted) toast.success("Connie posted it on the thread");
      }
      if (key !== "summary") onChanged?.();
    } catch (e) { toast.error(e?.response?.data?.detail || "Connie couldn't do that just now"); }
    finally { setBusy(null); }
  };

  return (
    <Panel testId="hub-connie-case-card"
           title={<span style={{ display: "inline-flex", alignItems: "center", gap: 10 }}><ConnieMark size={26} state={busy ? "thinking" : "idle"} orbit={false} />Connie on this case</span>}
           sub="One click each. Chases and replies go out straight away — anonymously, in the Connexis voice.">
      <div style={{ display: "flex", gap: 10, flexWrap: "wrap" }}>
        {ACTIONS.map(({ key, label, icon: Icon }) => (
          <button key={key} className="btn btn-ghost connie-glow-btn" onClick={() => run(key)} disabled={!!busy}
                  data-testid={`hub-connie-case-${key}`}>
            {busy === key ? <Loader2 className="animate-spin" /> : <Icon />} {label}
          </button>
        ))}
      </div>
      {out && (
        <div className="connie-bubble connie-in" style={{ marginTop: 16 }} data-testid="hub-connie-case-result">
          <div style={{ fontSize: 10.5, fontWeight: 700, letterSpacing: ".14em", textTransform: "uppercase", color: "var(--accent-text)", marginBottom: 6 }}>
            {out.key === "summary" ? "Connie's read" : out.key === "chase" ? "Chase" : "Posted on the thread"}
          </div>
          <ConnieText text={out.text} />
        </div>
      )}
    </Panel>
  );
}

export default ConnieCaseCard;
